import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { VeltProvider } from '@veltdev/react';

const rootContainer = document.getElementById('root');
const root = createRoot(rootContainer as HTMLElement);
// if develop is true in query params, then we use different api key
const develop = window.location.search.includes('develop=true');
const apiKey = develop ? 'TA66fUfxZVtGBqGxSTCz' : 'U2omkXino9MftBOvnqxF';
// if version is provided in query params, then we use that version
let version = window.location.search.includes('version=') ? window.location.search.split('version=')[1] : '';
if (!version) {
  if (develop) {
    version = '2.1.9';
  } else {
    version = 'latest';
  }
}
root.render(
  // @ts-ignore
  <VeltProvider apiKey={apiKey} config={{ version: version, develop: !!develop }}>
    <App />
  </VeltProvider>
);